import React from 'react'
import { Flex, Heading } from 'theme-ui'
import { Svg } from 'ui'
import GetStartedButton from 'components/HomePage/GetStartedButton'

interface FeaturesHeaderProps {
  title: string
  FeatureImage: React.ElementType
  featuredProfile?: string
}

export default function FeaturesHeader({
  title,
  FeatureImage,
  featuredProfile,
}: FeaturesHeaderProps): React.ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: ['column', 'row'],
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Flex sx={{ flexDirection: 'column', alignItems: ['center', 'flex-start'] }}>
        <Heading
          as="h1"
          sx={{
            fontSize: ['3.6rem', '4rem', '4.8rem'],
            fontWeight: 'bold',
            textAlign: ['center', 'start'],
            mb: ['2.4rem', '4.8rem'],
            maxWidth: '45rem',
          }}
        >
          {title}
        </Heading>
        <GetStartedButton dataTestId="features-get-started" featuredProfile={featuredProfile} />
      </Flex>
      <Svg
        svg={FeatureImage}
        descriptiveText={`${title} feature illustration`}
        sx={{
          width: ['28.8rem', '40rem', '60rem'],
          height: ['20.2rem', '28rem', '42rem'],
          alignSelf: 'right',
        }}
      />
    </Flex>
  )
}
